import { E_FR_LOC } from '@shared/constants/enums.const';
import { TTranslationKeys } from './translation.keys';

type TTranslations = Partial<{
  [key in E_FR_LOC]: TTranslationKeys
}>;

export const T9NS: TTranslations = {
  [E_FR_LOC.en]: {
    HomeTitle: 'IAS Plus — IFRS, global financial reporting and accounting resources',
  },
  [E_FR_LOC.de]: {
    HomeTitle: 'Nachrichten und Ressourcen zu den International Financial Reporting Standards (IFRS) und zur Finanzberichterstattung',
  },
  [E_FR_LOC.caEn]: {
    HomeTitle: 'Centre for Financial Reporting',
  },
  [E_FR_LOC.caFr]: {
    HomeTitle: 'Centre de l\'information financiere',
  },
  [E_FR_LOC.enUK]: {
    HomeTitle: 'UK Accounting Plus - a comprehensive source for all UK accounting, reporting and corporate governance news and information',
  },
};
